module.exports = __webpack_public_path__ + "img/xandr.fbbf9725.png";